import { render, staticRenderFns } from "./__Reason.vue?vue&type=template&id=28dd64e6&"
import script from "./__Reason.vue?vue&type=script&lang=js&"
export * from "./__Reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports